// ADR 5.9.26p §5 — the interstitial an unverified account sees.
//
// The verification link lands on the API's own `verified_page`
// (`routes/verification.rs:78`), never on the app host, so this tab is never
// navigated back to and never told anything. It therefore re-asks on **focus**:
// the learner clicks the link in another tab, comes back here, and the refresh
// that fires is the one endpoint that reports `email_verified` — `/features`
// cannot (`routes/features.rs:18`).
//
// Focus, not a poll: a timer would ask a hundred times for one answer, and the
// moment the answer can have changed is exactly the moment the tab is looked at
// again.

import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import { SectionHeading } from '../ui/SectionHeading'
import { useAuthSession } from './session'
import { PageFrame } from '../layout/frame/PageFrame'

export function VerifyEmailNotice() {
  const { t } = useTranslation()
  const { emailVerified, recheckVerification } = useAuthSession()

  useEffect(() => {
    const onFocus = () => void recheckVerification()
    window.addEventListener('focus', onFocus)
    return () => window.removeEventListener('focus', onFocus)
  }, [recheckVerification])

  if (emailVerified) return <Navigate to="/" replace />

  return (
    <PageFrame width="form" as="section" className="space-y-3">
      <SectionHeading>{t('verify_check_email')}</SectionHeading>
      <p className="text-sm text-ink">{t('verify_body')}</p>
    </PageFrame>
  )
}
